import formatPrice from './formatPrice';

const formatFeeBreakDownText = (faceValue, bookingFees, currency) =>
  bookingFees > 0
    ? `${formatPrice(
        currency.symbol,
        faceValue,
        currency.exponent,
      )} + ${formatPrice(
        currency.symbol,
        bookingFees,
        currency.exponent,
      )} Booking Fee`
    : null;

export default formatFeeBreakDownText;
